import type { PagePropertyResponse, PagePropertyResult, webpagesList } from "~/types/api/client/webpages";
import type { WebsiteDetails } from "~/types/api/client/websitedetails";
import { WebpageAPI } from "./webpage/webpageapi";
import type { Navigation, NavigationResponse } from "~/types/api/navigation";

export class WebsiteAPI {
    clientId: number;
    websiteId: number;

    constructor(clientId: number, websiteId: number) {
      this.clientId = clientId;
      this.websiteId = websiteId;
    }
  
    async getWebsiteDetails(): Promise<WebsiteDetails[]> {
        const response = await $fetch<WebsiteDetails[]>(`/api/client/websiteDetails?clientid=${this.clientId}&websiteid=${this.websiteId}`, {
            headers:useRequestHeaders(['cookie'])
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getWebpages(webpageId?: number): Promise<webpagesList[]> {

        interface webPagesQuery {
            clientid: number,
            websiteid: number,
            webpageid?: number
        }

        let query: webPagesQuery = {
            clientid: this.clientId,
            websiteid: this.websiteId,
        }

        if(webpageId) {
            query.webpageid = webpageId
        }

        const response = await $fetch<webpagesList[]>(`/api/client/webpages`, {
            headers:useRequestHeaders(['cookie']),
            query: query
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getNews(): Promise<newsItem[]> {
        const response = await $fetch<newsItem[]>(`/api/client/news`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                websiteid: this.websiteId
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getLinks(): Promise<Navigation[]> {
        const router = useRouter()
        const response = await $fetch(`/api/navigation`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                websiteid: this.websiteId
            }
        }).catch<NavigationResponse>(async (err) => {
            if(err.statusCode >= 400) {
                router.push(`/login?redirect_uri=${encodeURIComponent(router.currentRoute.value.fullPath)}`)
            }
        })
        return response
    }

    webpage(webpageid: number) {
        return new WebpageAPI(this.clientId, this.websiteId, webpageid)
    }

    async getPageProperty(pageId?: number, property?: string): Promise<PagePropertyResult[]> {
        const response = await $fetch<PagePropertyResponse>(`/api/client/pageproprety?pageId=${pageId}`, {
            headers:useRequestHeaders(['cookie'])
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        if(property) {
            return response.result.filter(x => x.propName == property)
        }
        return response
    }

  }